export enum TreeItemType {
  topic = 'topic',
  teachingUnit = 'teachingUnit',
}

export type CustomData = { uuid?: string; type: TreeItemType };
